import { CSSProperties } from 'react';
import { UploaderListView } from './uploader-list/uploader-list.view';
import { IDataPackageFileDescriptor, IUploader } from '@vivli/shared/features/data-package/infrastructure/interface';
import { DataPackageTypeEnum } from '@vivli/features/studies/infrastructure/enum';
import { FileUploaderView } from './file-uploader.view';

const containerStyle: CSSProperties = {
    boxShadow: '0px 0px 5px 0px rgba(255,255,255,0.65)',
    padding: '5px',
    backgroundColor: 'rgba(255,255,255,0.65)'
};

const warningTextStyle: CSSProperties = {
    padding: '10px 0',
    textAlign: 'center',
    fontWeight: 'bold'
};

interface UploaderViewProps extends IUploader {
    files?: IDataPackageFileDescriptor[];
    preExistingFiles?: IDataPackageFileDescriptor[];
    isLoading?: boolean;
    scrollEnabled?: boolean;
    packageType?: DataPackageTypeEnum;
    readonly?: boolean;
    secondaryFilesToShow?: IDataPackageFileDescriptor[];
    hybridMode?: boolean;
}

export const UploaderView = (props: UploaderViewProps) => {
    return (
        <div style={containerStyle}>
            <div style={warningTextStyle}>
                <div style={{ color: 'red' }}>WARNING</div> If you navigate away from this page when a file upload is underway (i.e.
                clicking on another tab or closing the browser), all ongoing uploads will be canceled.
            </div>

            <div>
                <FileUploaderView {...props}>
                    <UploaderListView {...props} />
                </FileUploaderView>
            </div>
        </div>
    );
};
